import { createContext } from 'react';

export default createContext({
  branch: null,
  trigger: '',
  triggerFired: false,
  selector: null,
  triggerCurrentTest: () => {},
  showShield: false
});
